var _rect, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgActiveMileage(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_258_60809",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 20,
    height: 20
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_258_60809)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.83647 12.7885C9.13564 13.0876 9.51841 13.2267 9.9848 13.2058C10.4512 13.185 10.7917 13.0181 11.0065 12.7052L15.5288 6.15396L8.96147 10.6602C8.64313 10.8783 8.46661 11.2113 8.43189 11.6594C8.39716 12.1076 8.53202 12.484 8.83647 12.7885ZM4.25001 16.25C4.01932 16.25 3.80751 16.1974 3.61459 16.0921C3.42182 15.9868 3.26501 15.8343 3.14418 15.6346C2.79918 15.0246 2.53612 14.3862 2.35501 13.7196C2.1739 13.0529 2.08334 12.3686 2.08334 11.6667C2.08334 10.5726 2.2914 9.5441 2.70751 8.58104C3.12362 7.61785 3.688 6.77993 4.40064 6.06729C5.11327 5.35465 5.95119 4.79028 6.91439 4.37417C7.87744 3.95806 8.90598 3.75 10 3.75C11.0854 3.75 12.1041 3.95458 13.0561 4.36375C14.008 4.77292 14.8416 5.33035 15.5569 6.03604C16.2722 6.74174 16.84 7.56708 17.2604 8.51208C17.6808 9.45708 17.8953 10.4723 17.9038 11.5577C17.9124 12.2842 17.8283 12.992 17.6515 13.681C17.4747 14.3702 17.2051 15.0321 16.8429 15.6667C16.7275 15.8664 16.5721 16.0135 16.3767 16.1081C16.1811 16.2027 15.9679 16.25 15.7371 16.25H4.25001Z",
    fill: "#155DFC"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgActiveMileage);
export default __webpack_public_path__ + "static/media/Active Mileage.e58f113cb1be900554abd264207eb69a.svg";
export { ForwardRef as ReactComponent };